import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { CoreService } from 'src/app/services/core.service';

import { DOWNLOAD_APK } from 'src/app/utils/routing/routes.model';
import { User } from '@mocca-technologies/model';
import { AuthHttpService } from 'src/app/services/auth-http.service';
import { Router } from '@angular/router';
import { SharedRelayService } from 'src/app/services/shared-relay.service';
import { PageStatusService } from 'src/app/services/page-status.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';



type Page =
    | 'operations'
    | 'region-maps'
    | 'ap-operations'
    | 'devices'
    | 'fleet'
    | 'logbook'
    | 'planning'
    | 'relay'
    | 'schedule'
    | 'new-trajectories-page'
    | 'create-trajectory'
    | 'battery-charging-register';

@Component({
    selector: 'app-navigation-bar',
    templateUrl: './navigation-bar.component.html',
    styleUrls: ['./navigation-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationBarComponent implements OnInit {
    dark: boolean;

    user: User;
    isHome: boolean;

    /**
     * Returns if the current page is the home page
     * @returns
     */
    isHomePage(): boolean {
        return this.pageStatusService.isHomePage;
    }

    constructor(
        private menu: MenuController,
        private core: CoreService,
        private sharedRelay: SharedRelayService,
        private cdr: ChangeDetectorRef,
        private authService: AuthHttpService,
        private pageStatusService: PageStatusService,
        private router: Router,
        public translateService: TranslateService
    ) {
        //this.setupDarkMode();
    }

    ngOnInit(): void {
        this.core.user$.subscribe((user) => {
            this.user = user;
            this.cdr.detectChanges();
        });
        this.core.isHome$.subscribe((isHome) => {
            this.isHome = isHome;
            this.cdr.detectChanges();
        });
        this.updateUser();
    }

    handleNavigationClick(value: Page) {
        // TODO: add NGRX store-router
        this.router.navigate(['/' + value], { replaceUrl: true }).then(success => {
            if (success) {
                !environment.production && console.log('Navigation successful!');
            } else {
                console.error('Navigation failed!');
            }
        }).catch(error => {
            console.error('Navigation error:', error);
        });
    }

    /**
     * Changes the application language
     * @param lang language code
     */
    changeLanguage(lang: string) {
      localStorage.setItem('lang', lang);
      if(localStorage && this.translateService){
        this.translateService?.setDefaultLang(localStorage?.getItem('lang'));
        this.translateService?.use(localStorage?.getItem('lang'));
      }
      //window.location.reload();
    }

    handleDarkSwitch(ev: any) {
        const { checked } = ev.detail;
        localStorage.setItem('darkMode', JSON.stringify(checked));
        document.body.classList.toggle('dark', checked);
    }

    handleLogoutClick() {
        this.menu.close().then((_) => {
            this.sharedRelay.items.clear();
            this.sharedRelay.schOperation = null;
            this.authService.logout();
        });
    }

    downloadAPK() {
        let link = document.createElement("a");
        link.download = "MOCCA_MobileSDK.apk";
        link.href = DOWNLOAD_APK;
        link.click();
    }

    private setupDarkMode() {
        // Getting local values
        const localDark = JSON.parse(localStorage.getItem('darkMode'));
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

        // Setting theme
        this.dark = localDark ?? prefersDark.matches;
        document.body.classList.toggle('dark', this.dark);
    }

    checkUserRestricted(): boolean {
        this.updateUser();
        return this.core.userOrganizationTypeRestricted(this.user);
    }

    updateUser() {
        const newUser = JSON.parse(localStorage.getItem('user'));

        if (JSON.stringify(this.user) !== JSON.stringify(newUser)) {
            this.user = newUser;
            !environment.production && console.log('User updated:', this.user);
            this.cdr.detectChanges(); // Manually trigger change detection
        }
    }

    getUser(): User {
        this.updateUser();
        return this.user;
    }
}
